const adminMiscRoutes = [
    { path: 'import', component: () => import('pages/sot.bot.admin/import/ImportIndex.vue') },
    { path: 'search', component: () => import('pages/sot.bot.admin/search/SearchUserPage.vue') },

    { path: 'denied', component: () => import('pages/sot.bot.admin/denied/DeniedPage.vue') }, // плееры,
];

export default adminMiscRoutes;
